import { ApiKey, ApiPathManager, ServiceCode } from "app/shared/services/api-path";
import { getDataHeaders, getUserHeader } from "app/shared/services/header-builder";
import { REQUESTINPUT } from "app/shared/services/services-model.type";
import { instance } from "app/shared/util/token-store";
import { FetchTransferInfoRequest } from "../reducer/types";
import { Constant } from "app/shared/constant/constant";

const getServiceCode = (type?: string) => {
  switch (type) {
    case Constant.TEMPLATE_TYPE.INTERNAL_TRANSFER:
      return ServiceCode.TRANSFER_LOCAL_OTHER_CIF;
    case Constant.TEMPLATE_TYPE.INTERBANK_TRANSFER:
      return ServiceCode.TRANSFER_FOREIGN;
    case Constant.TEMPLATE_TYPE.INTERBANK_FAST_TRANSFER:
      return ServiceCode.TRANSFER_247;
    case Constant.TEMPLATE_TYPE.DEPOSIT_TO_STOCK_TRADE_ACCOUNT:
      return ServiceCode.TRANSFER_STOCK;
    case Constant.TEMPLATE_TYPE.CASH_BY_CODE_TEMPLATE:
      return ServiceCode.TRANSFER_BY_CODE;
    default:
      return "";
  }
};

export const fetchTransferInfoService = async (actionRq: FetchTransferInfoRequest) => {
  const { action, massageID, url } = ApiPathManager(ApiKey.TRANS_CIF_TRANSFER_INFO);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const serviceCode = getServiceCode(actionRq.payload);
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
    TRANSFER: {
      SERVICE_CODE: serviceCode,
    },
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};
